import React from "react";
import { Link } from "react-router-dom";
import Seo from "../../../components/public/Seo";
import "../../../styles/legal.css";

export default function CookieNotice() {
  return (
    <>
      <Seo
        title="Cookies & Analytics — Veya"
        description="How Veya uses cookies, local storage, analytics and similar technologies."
      />

      <main className="legal-page">
        <section className="legal-hero legal-hero--narrow">
          <p className="legal-kicker">Cookies & Analytics</p>
          <h1>Cookies & Analytics Notice</h1>
          <p>
            This notice explains how Veya may use cookies, local storage,
            analytics and similar technologies to operate and improve the
            platform.
          </p>
          <p className="legal-updated">Last updated: May 2026</p>
        </section>

        <article className="legal-document">
          <section>
            <h2>1. What cookies and local storage are</h2>
            <p>
              Cookies are small files stored on your device by a website. Local
              storage is a browser-based storage method that can remember
              information between sessions.
            </p>
            <p>
              Similar technologies may also be used to understand platform
              usage, improve performance, support security and remember
              preferences.
            </p>
          </section>

          <section>
            <h2>2. How Veya may use these technologies</h2>
            <p>Veya may use cookies, local storage and similar tools to:</p>
            <ul>
              <li>keep users signed in;</li>
              <li>manage authentication and account sessions;</li>
              <li>remember preferences, selected country or region settings;</li>
              <li>support saved items, edits, bag and fitting room features;</li>
              <li>understand how people use Veya;</li>
              <li>measure product engagement and platform performance;</li>
              <li>identify errors, bugs and technical issues;</li>
              <li>protect accounts, prevent misuse and improve security.</li>
            </ul>
          </section>

          <section>
            <h2>3. Analytics</h2>
            <p>
              Veya may use analytics tools to understand how shoppers, visitors
              and merchants interact with the platform. This may include pages
              visited, features used, products viewed, interaction events,
              device and browser information, approximate location, session
              information and error data.
            </p>
            <p>
              Analytics helps us improve the product experience, identify
              issues, understand demand signals and support merchant-facing
              insights.
            </p>
          </section>

          <section>
            <h2>4. Essential technologies</h2>
            <p>
              Some cookies, local storage or similar technologies may be
              essential for Veya to work properly. For example, they may be
              needed for login, account security, navigation, saved states,
              fitting room functionality or merchant dashboard access.
            </p>
          </section>

          <section>
            <h2>5. Managing cookies</h2>
            <p>
              You can usually control or delete cookies through your browser
              settings. Blocking some cookies or storage may affect how Veya
              works, including login, saved items, preferences, edits, bag and
              try-on features.
            </p>
          </section>

          <section>
            <h2>6. Personal information</h2>
            <p>
              Where cookies, analytics or similar technologies involve personal
              information, Veya handles that information in accordance with our{" "}
              <Link to="/legal/privacy">Privacy Policy</Link>.
            </p>
          </section>

          <section>
            <h2>7. Changes to this notice</h2>
            <p>
              We may update this notice from time to time as Veya’s features,
              analytics or technical services change.
            </p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p>
              For questions about cookies or analytics, contact{" "}
              <a href="mailto:hello@veya.co.nz">hello@veya.co.nz</a>.
            </p>
          </section>
        </article>
      </main>
    </>
  );
}